import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const UserMenu = ({ collapsed }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef();

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        className="flex items-center gap-2 w-full bg-transparent border-none outline-none cursor-pointer"
        onClick={() => setShowDropdown((prev) => !prev)}
      >
        <img
          src={user?.avatar || "/avatar.jpeg"}
          alt="User"
          className="rounded-full w-9 h-9 object-cover flex-shrink-0"
        />
        {!collapsed && (
          <div className="text-left flex-1">
            <p className="text-white text-sm font-semibold leading-tight">{user?.name || "User"}</p>
            <p className="text-white/60 text-xs leading-tight">Admin</p>
          </div>
        )}
        {!collapsed && <ChevronRight size={14} className="text-white/60 flex-shrink-0" />}
      </button>

      {showDropdown && (
        <ul className="absolute bottom-12 left-0 bg-white rounded shadow-lg py-1 w-40 z-50">
          <li>
            <Link className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" to="/profile">
              Profile
            </Link>
          </li>
          <li>
            <button
              className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
              onClick={() => {
                localStorage.clear();
                window.location.href = "/login";
              }}
            >
              Logout
            </button>
          </li>
        </ul>
      )}
    </div>
  );
};

export default UserMenu;
